import { renderInvalidatedColors } from './chart-util';

/**
 * Adds options for LINE charts.
 */
export function preRender(data, options) {
  data.plotOptions.area = {
    lineWidth: (options.series.length > 1) ? 1 : 0,
    lineColor: '#fff',
    linecap: 'square',
    fillOpacity: 1.0,
    enableMouseTracking: options.interactive,
    stacking: options.stacking,
    states: {
      hover: {
        halo: {
          opacity: 1,
          size: 4
        },
        lineWidthPlus: 0
      }
    }
  };
  data.plotOptions.series = {
    marker: {
      symbol: 'circle',
      radius: 0,
      lineWidth: 0,
      lineColor: null
    }
  };
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.plotOptions.area.lineWidth = 1.5;
      // data.plotOptions.area.linecap = 'butt';
    }
  }
  return data;
}


export function postRender(highchart, options) {
  roundLineJoins(highchart, options);
}


function roundLineJoins(highchart, options) {
  const selector = 'g.highcharts-series-group g.highcharts-series path';
  const paths = highchart.container.querySelectorAll(selector);
  for (let i = 0; i < paths.length; i++) {
    paths[i].setAttribute('stroke-linejoin', 'bevel');
    if (__WSJ__) {
      if (options.size === 'print-wsj') {
        paths[i].setAttribute('stroke-linecap', 'butt');
      }
    }
  }
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    renderInvalidatedColors(rendered, invalidated);
  }
}



// WEBPACK FOOTER //
// ./src/chart/inner/chart-area.js